import { Component, OnInit } from '@angular/core';
import { FantasyGameQuery } from 'projects/core/src/lib/modules/loyalty/fantasy/fantasy-game.query';
import { FantasyGame } from 'projects/core/src/lib/modules/loyalty/fantasy/models/fantasy-game.model';
import { Observable } from 'rxjs/internal/Observable';
import * as _moment from 'moment';
import { FantasyGameService, LeaderboardType, LeaderboardV2Entry, LeaderboardV2Query, LeaderboardV2Service } from '@fgb/core';
import { firstValueFrom } from 'rxjs';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { take } from 'rxjs/operators';

@Component({
  selector: 'fgb-fantasy-game-play-v2',
  templateUrl: './fantasy-game-play-v2.component.html',
  styleUrl: './fantasy-game-play-v2.component.scss',
})
export class FantasyGamePlayV2Component implements OnInit {
  screenType = ScreenType;

  currentGames$: Observable<FantasyGame[]>;
  futureGames$: Observable<FantasyGame[]>;

  LeaderboardType: LeaderboardType = LeaderboardType.FantasyPoints;
  currentUser: LeaderboardV2Entry | undefined;

  constructor(
    private fantasyQuery: FantasyGameQuery,
    private leaderboardV2Service: LeaderboardV2Service,
    private leaderboardV2Query: LeaderboardV2Query,
    private fantasyGameService: FantasyGameService
  ) {}

  ngOnInit(): void {
    firstValueFrom(this.leaderboardV2Service.fetchLeaderboardV2(undefined, this.LeaderboardType)).then(() => {
      this.currentUser = this.leaderboardV2Query.getLeaderboardV2().find((entry) => entry.IsCurrentUser);
    });

    // fetch games
    this.fantasyGameService.fetchFantasyGamesV2(10, false, true).subscribe();

    this.currentGames$ = this.fantasyQuery.selectCurrentGames();

    // fallback trigger fetch for future games if no current
    this.currentGames$.pipe(take(1)).subscribe((games) => {
      if (!games.length || games.length === 0) {
        this.fantasyGameService.fetchFantasyGamesV2(10, false, true).subscribe();

        this.futureGames$ = this.fantasyQuery.selectAll();
      }
    });
  }
}
